import axiosBackEnd from "../config/axios/axios-back-end";

const getSignStatus = async (data) => {
  const result = await axiosBackEnd.post("/api/envelope/get-sign-status", data);
  return result.data;
};

const updateEnvelopeStatus = async (data) => {
  // const result = await axiosBackEnd.put("/api/signatureqc/status", data);
  const result = await axiosBackEnd.put("/api/envelope/status", data);
  return result.data;
};

const resendFailedEnvelopes = async (data) => {
  const result = await axiosBackEnd.post("/api/envelope/retry", data);
  return result.data;
};

export { getSignStatus, updateEnvelopeStatus, resendFailedEnvelopes, };
